export const DEFAULT_API_TOKEN_WAIT_TIMEOUT_MS = 12_000;
export const DEFAULT_API_TOKEN_WAIT_INTERVAL_MS = 100;

const wait = (ms) => new Promise((resolve) => {
  setTimeout(resolve, ms);
});

export async function waitForApiToken(getApiToken, options = {}) {
  if (typeof getApiToken !== 'function') {
    return null;
  }

  const {
    timeoutMs = DEFAULT_API_TOKEN_WAIT_TIMEOUT_MS,
    intervalMs = DEFAULT_API_TOKEN_WAIT_INTERVAL_MS,
  } = options;
  const startedAt = Date.now();

  while (Date.now() - startedAt < timeoutMs) {
    try {
      const token = await getApiToken();
      if (token) {
        return token;
      }
    } catch {
      // Auth providers can reject while hydration is still settling.
    }

    await wait(Math.min(intervalMs, Math.max(timeoutMs - (Date.now() - startedAt), 0)));
  }

  try {
    const token = await getApiToken();
    return token || null;
  } catch {
    return null;
  }
}
